import { createSelector } from '@/redux/lib/createSelector.js';

export const issues = (state) => state?.issues?.issues;
export const issueById = createSelector('issueById', [issues, (_, issueId) => issueId], (issues, issueId) => issues?.find((issue) => issue?.id === issueId));
export const issuesByAppId = createSelector('issuesByAppId', [issues, (_, appId) => appId], (issues, appId) =>
  issues
    ?.filter((issue) => issue?.appId === appId)
    ?.sort((a, b) => {
      if (a?.actionId === null && b?.actionId !== null) return -1;
      if (a?.actionId !== null && b?.actionId === null) return 1;
      return (a?.actionId ?? 0) - (b?.actionId ?? 0);
    })
);
